if (!customElements.get('songsong-product')) {
  customElements.define('songsong-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('submit', event => this.addToCart(event));
      this.variants = JSON.parse(this.querySelector('[data-variants]').content.textContent);
      this.thumbs = Array.from(this.querySelectorAll('.ss-pdp-thumbs button'));
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        if (this.swipedUntil > Date.now()) return;
        const thumb = event.target.closest('button[data-image]');
        if (thumb) this.showImage(thumb.dataset.image, thumb.dataset.alt);
        const step = event.target.closest('[data-step]');
        if (step) this.step(Number(step.dataset.step));
        if (event.target.closest('[data-zoom]')) {
          const main = this.querySelector('[data-main-image]');
          this.showImage(main.getAttribute('src'), main.alt);
          this.dialog.showModal();
        }
        if (event.target.closest('[data-close]')) this.dialog.close();
      });
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.step(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      this.querySelectorAll('[data-swipe]').forEach(surface => {
        surface.addEventListener('pointerdown', event => {
          if (event.pointerType === 'mouse') return;
          this.touch = {x:event.clientX, y:event.clientY, id:event.pointerId};
        });
        surface.addEventListener('pointerup', event => {
          if (!this.touch || this.touch.id !== event.pointerId) return;
          const dx=event.clientX-this.touch.x, dy=event.clientY-this.touch.y;
          this.touch=null;
          if (Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.3) {
            this.swipedUntil=Date.now()+400; this.step(dx<0?1:-1);
          }
        });
        surface.addEventListener('pointercancel',()=>{this.touch=null});
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-option-radio]')) this.updateVariant();
      });
      if (this.querySelector('[data-option-radio]')) this.updateVariant();
    }
    async addToCart(event) {
      const form = event.target;
      if (!form.matches('form') || !form.querySelector('[name="id"]')) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.adding || !form.reportValidity()) return;
      this.adding = true;
      const buy = event.submitter?.matches('[data-buy-button]');
      const buttons = Array.from(form.querySelectorAll('[data-add-button],[data-buy-button]'));
      const states = buttons.map(button => ({disabled: button.disabled, text: button.textContent}));
      const modal = this.closest('#SSQuickView');
      const close = modal?.querySelector('[data-quick-close]');
      const status = form.querySelector('[data-cart-status]');
      const data = new FormData(form);
      const root = window.Shopify?.routes?.root || '/';
      buttons.forEach(button => { button.disabled = true; });
      if (event.submitter) event.submitter.textContent = modal?.dataset.adding || 'Adding…';
      if (close) close.disabled = true;
      status.textContent = '';
      try {
        const response = await fetch(root + 'cart/add.js', {method: 'POST', body: data, headers: {Accept: 'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add this item. Please try again.');
        status.textContent = modal?.dataset.added || 'Added to your cart.';
        document.dispatchEvent(new CustomEvent('cart:updated', {detail: {item: result}}));
        if (buy) { if(window.ssOpenCart)await window.ssOpenCart(event.submitter);else window.location.assign(root + 'cart'); return; }
        window.ssCartFly?.(this, event.submitter);
      } catch (error) {
        status.textContent = error.message || 'Unable to add this item. Please try again.';
      } finally {
        this.adding = false;
        if (close) close.disabled = false;
        buttons.forEach((button, index) => { button.disabled = states[index].disabled; button.textContent = states[index].text; });
        if (this.querySelector('[data-option-radio]')) this.updateVariant();
      }
    }
    disconnectedCallback() { if (this.dialog?.open) this.dialog.close(); }
    updateVariant() {
      const values=Array.from(this.querySelectorAll('[data-option-index]')).map(group=>group.querySelector('input:checked')?.value);
      const variant=this.variants.find(v=>v.options.length===values.length && v.options.every((v,i)=>v===values[i]));
      const input=this.querySelector('[data-selected-variant]');
      input.value=variant?variant.id:''; input.disabled=!variant;
      this.querySelectorAll('[data-price-for]').forEach(price=>{price.hidden=!variant || price.dataset.priceFor!==String(variant.id)});
      this.querySelector('[data-variant-message]').hidden=!!variant;
      const button=this.querySelector('[data-add-button]');
      button.disabled=this.adding || !variant || !variant.available;
      this.querySelector('[data-buy-button]').disabled = button.disabled;
      button.textContent=variant?.available?this.dataset.addLabel:this.dataset.soldLabel;
      if (!variant) button.textContent=this.querySelector('[data-variant-message]').textContent;
      const thumb=this.thumbs.find(t=>t.dataset.imageId===String(variant?.featured_image?.id));
      if (thumb) this.showImage(thumb.dataset.image,thumb.dataset.alt);
    }
    step(direction) {
      if (this.thumbs.length<2) return;
      const index=Math.max(0,this.thumbs.findIndex(t=>t.getAttribute('aria-pressed')==='true'));
      const thumb=this.thumbs[(index+direction+this.thumbs.length)%this.thumbs.length];
      this.showImage(thumb.dataset.image,thumb.dataset.alt);
    }
    showImage(src, alt) {
      if (!src) return;
      this.querySelectorAll('[data-main-image],[data-zoom-image]').forEach(image=>{
        image.src=src; image.alt=alt||'';
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
          image.getAnimations().forEach(a=>a.cancel());
          image.animate([{opacity:.25,transform:'translateX(6px)'},{opacity:1,transform:'translateX(0)'}],{duration:260,easing:'ease-out'});
        }
      });
      this.thumbs.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.image===src)));
    }
  });
}
